import EnhancedTab from 'lib/designSystem/TabSimulation';
import { Warranty } from 'lib/types/models';
import React from 'react';

import File from './File';
import WarrantySummary from './WarrantySummary';

const WarrantyDetailTabs: React.FC<{
  warranty: Warranty;
}> = ({ warranty }) => {
  const hideDocument = ['LEAD', 'CANCELLED', 'CLAIMED', 'LOST'];
  const tabs = [
    {
      label: 'Resumen',
      component: <WarrantySummary warranty={warranty} pruffConnect />,
    },
    {
      label: 'Documento',
      component: <File warranty={warranty} />,
      disabled: hideDocument.includes(warranty.status),
    },
  ];

  const title = warranty.folioId
    ? `Garantía ${warranty.displayId}`
    : `Cotización ${warranty.id}`;

  return <EnhancedTab title={title} tabs={tabs} />;
};

export default WarrantyDetailTabs;
